import React from "react";
import { KpiCard, Panel } from "@/pages/dashboard/widgets";
import { inr } from "@/lib/dashboard";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from "recharts";

export default function FinanceView({ data }) {
  if (!data) return null;
  const aging = data.aging || {};
  const chart = ["Current", "1-30", "31-60", "61-90", "90+"].map((b) => ({ bucket: b === "Current" ? "Not due" : b, value: aging[b] ?? 0 }));
  const g = data.gst || {};
  return (
    <div className="space-y-6" data-testid="finance-view">
      <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
        <KpiCard testid="fin-kpi-receivable" label="Receivables" value={inr(data.receivable)} accent="text-rose-600" />
        <KpiCard testid="fin-kpi-overdue" label="Overdue invoices" value={data.overdue_invoices ?? 0} accent="text-amber-600" />
        <KpiCard testid="fin-kpi-collections" label="Today's collections" value={inr(data.todays_collections)} accent="text-emerald-600" />
        <KpiCard testid="fin-kpi-revenue" label="Revenue (posted)" value={inr(data.revenue)} accent="text-indigo-600" />
      </div>
      <div className="grid gap-6 lg:grid-cols-2">
        <Panel title="Receivables aging">
          <div className="h-56" data-testid="fin-aging-chart">
            <ResponsiveContainer width="100%" height="100%">
              <BarChart data={chart}>
                <CartesianGrid strokeDasharray="3 3" stroke="#eef2f7" />
                <XAxis dataKey="bucket" tick={{ fontSize: 11 }} />
                <YAxis tick={{ fontSize: 11 }} tickFormatter={(v) => `${(v / 1000).toFixed(0)}k`} />
                <Tooltip formatter={(v) => inr(v)} />
                <Bar dataKey="value" fill="#f43f5e" radius={[4, 4, 0, 0]} />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </Panel>
        <Panel title="GST summary (posted)">
          <dl className="space-y-2 text-sm">
            <div className="flex justify-between border-b border-slate-100 py-1"><dt className="text-slate-500">CGST</dt><dd className="tabular-nums text-slate-700">{inr(g.cgst)}</dd></div>
            <div className="flex justify-between border-b border-slate-100 py-1"><dt className="text-slate-500">SGST</dt><dd className="tabular-nums text-slate-700">{inr(g.sgst)}</dd></div>
            <div className="flex justify-between border-b border-slate-100 py-1"><dt className="text-slate-500">IGST</dt><dd className="tabular-nums text-slate-700">{inr(g.igst)}</dd></div>
            <div className="flex justify-between border-t border-slate-200 pt-1 font-semibold"><dt className="text-slate-700">Total tax</dt><dd className="tabular-nums text-slate-900">{inr(g.total_tax)}</dd></div>
            <div className="flex justify-between py-1"><dt className="text-slate-500">Advances held</dt><dd className="tabular-nums text-indigo-600">{inr(data.advances)}</dd></div>
          </dl>
        </Panel>
      </div>
    </div>
  );
}
